module.exports = __webpack_public_path__ + "static/media/bots.ffaaa3cf.svg";